import React from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  FaRobot,
  FaBrain,
  FaReact,
  FaBook,
  FaNewspaper,
  FaCog,
  FaDoorOpen,
  FaAndroid,
  FaMicrochip,
  FaBell,
  FaMoon,
  FaSun,
} from "react-icons/fa";

function IconMenyu({ toggleUserPanel, darkMode, toggleDarkMode }) {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="menyu-container">
      {/* Main Navigation */}
      <div className="menyu-main">
        <div
          className={`menyu-qiymat ${location.pathname === "/mantiq" ? "active" : ""}`}
          onClick={() => navigate("/mantiq")}
          style={{ cursor: "pointer" }}
        >
          <FaBrain className="icon-menyu" />
          <span>Mantiq</span>
        </div>
        <NavLink className="menyu-qiymat" to="/web/">
          <FaReact className="icon-menyu" />
          <span>Web</span>
        </NavLink>
        <NavLink className="menyu-qiymat" to="/mobil">
          <FaAndroid className="icon-menyu" />
          <span>Mobil</span>
        </NavLink>
        <NavLink className="menyu-qiymat" to="/algoritm">
          <FaMicrochip className="icon-menyu" />
          <span>Algoritm</span>
        </NavLink>
        <NavLink className="menyu-qiymat" to="/robot">
          <FaRobot className="icon-menyu" />
          <span>Robot</span>
        </NavLink>
        <NavLink className="menyu-qiymat" to="/kitob">
          <FaBook className="icon-menyu" />
          <span>Kitob</span>
        </NavLink>
        <NavLink className="menyu-qiymat" to="/yangilik">
          <FaNewspaper className="icon-menyu" />
          <span>Yangilik</span>
        </NavLink>
      </div>

      {/* Footer / Utility Navigation */}

    </div>
  );
}

export default IconMenyu;
